import { ProtectedServerPlaceEvent } from 'gleblu-socket-api';
import { Action } from 'redux-act';
import { put, takeEvery } from 'redux-saga/effects';

import { toDto as toRegularHoursDto } from '../../../models/adapters/RegularHoursAdapter';
import { fromDto as reservationFromDto } from '../../../models/adapters/ReservationAdapter';
import { regularHoursSaved, regularHoursSaveFailed, saveRegularHours, SaveRegularHoursPayload } from '../../actions/setting/saveHours';
import getAuthenticationToken from '../getAuthenticationToken';
import getProtectedResponse from '../getProtectedResponse';

function* saveRegularHoursSaga({ payload }: Action<SaveRegularHoursPayload>) {
  const { regularHours, placeUuid } = payload;
  const token = yield getAuthenticationToken();
  const regularHoursDto = toRegularHoursDto(regularHours, placeUuid);
  const response = yield getProtectedResponse(ProtectedServerPlaceEvent.updateHours, token, { regularHoursDto });
  if (!response.error) {
    const { affectedReservations: affectedReservationDtos } = response;
    const affectedReservations = affectedReservationDtos.map(reservationFromDto);
    yield put(regularHoursSaved({ regularHours, placeUuid, affectedReservations }));
  } else {
    yield put(regularHoursSaveFailed({ placeUuid }));
  }
}

export default function* watchSaveHoursSaga() {
  yield takeEvery(saveRegularHours, saveRegularHoursSaga);
}
